import { getApiUrl } from 'modules/Url';

export type FetchTotalPlaysByEpisodeParams = {
  webStationId: string;
};

export type TotalPlaysByEpisodeRow = {
  episodeId: number;
  title: string;
  plays: number;
  publishOnUnixTimestamp: number;
  rank: number;
};

export type FetchTotalPlaysByEpisodeResponse = {
  data: {
    columnHeaders: [
      { name: 'Episode Title'; type: 'string' },
      { name: 'Episode ID'; type: 'integer' },
      { name: 'Plays'; type: 'integer' },
      { name: 'Published Time (UTC)'; type: 'integer' },
      { name: 'Rank'; type: 'integer' }
    ];
    rows: TotalPlaysByEpisodeRow[];
  };
  kind: 'totalPlaysByEpisode';
  stationId: number;
};

export function getTotalPlaysByEpisodeUrl({
  webStationId,
  csvFilename,
}: FetchTotalPlaysByEpisodeParams & {
  csvFilename?: string;
}) {
  return getApiUrl({
    path: `analytics/station/webStationId:${webStationId}/totalPlaysByEpisode`,
    queryParameters: {
      csvFilename,
    },
  });
}

export async function fetchTotalPlaysByEpisode({
  webStationId,
}: FetchTotalPlaysByEpisodeParams): Promise<FetchTotalPlaysByEpisodeResponse> {
  try {
    const url = getTotalPlaysByEpisodeUrl({ webStationId });
    const resp = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
    });

    if (resp.ok) {
      return resp.json();
    }

    throw new Error('Could not fetch station total plays by episodes');
  } catch (err) {
    throw new Error(err.message);
  }
}
